import React from "react";
import { Link } from "react-router-dom";
import Layout from "../Components/Layout/Layout";

const SearchProfile = () => {
  const data = JSON.parse(localStorage.getItem("serach"));
  return (
    <>
      <Layout>
        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>Stolen Pets</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Stolen Pets
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="main-body">
            <div className="row gutters-sm d-flex justify-content-center">
              <div className="col-md-8">
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="row">
                      <div className="card shadow-none border-none">
                        <div className="card-body">
                          <div className="d-flex flex-column align-items-center text-center">
                            <img
                              src={
                                data?.images[0]?.image
                                  ? data?.images[0]?.image
                                  : "/assets/images/bg/inner-banner-img.png"
                              }
                              alt="Admin"
                              className="rounded-circle"
                              style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="form-wrapper wow fadeInUp"
                      data-wow-duration="1.5s"
                      data-wow-delay=".2s"
                    >
                      <>
                        <div className="padding-50">
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">First Name :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.first_name}
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">Last Name :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.last_name}
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">Email :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.email}
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">Address :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.address}
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">Pet Breed :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.pet_breed}
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">Pet Color :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.pet_color}
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">Pet Name :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.pet_name}
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">MicroPhone :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.microchip_no}
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-6">
                              <h6 className="mb-0">Phone :</h6>
                            </div>
                            <div className="col-sm-6 text-secondary">
                              {data?.phone}
                            </div>
                          </div>
                          <hr />
                        </div>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default SearchProfile;
